export default "__VITE_ASSET__dad591ec__"